export default __webpack_public_path__ + "img/9726db9c527497399507b293b6346276.png";